
import { NavLink } from 'react-router-dom';
// material-ui
import { Box, Grid, Typography, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";
import { contentWidth } from 'store/constant';
import logo from 'assets/images/logo.svg';
import LocalizationSection from '../Header/LocalizationSection/index';
import config from '../../../config';
import useAuth from 'hooks/useAuth';

// ==============================|| MAIN  HEADER ||============================== //

const Footer = () => {
    const market = useAuth();
    const market_settings = market?.company?.organisation
    const market_config = useSelector((state) => state?.shop?.config);
    const locales_admin = Array.isArray(market_config?.locale) ? market_config?.locale : market_config?.locale ? [market_config.locale] : [];
    const languages_admin = locales_admin?.map(lang => lang.substring(0, 2));
    const intl = useIntl();
    const current_lang = useSelector((state) => state.customization.locale);
    const { isLoggedIn } = useAuth();
    const theme = useTheme();
    const supportLinks = [
        // { title: <FormattedMessage id="footer.column-one-link-one"/>, url: isLoggedIn ? '/contact' : '', extUrl: isLoggedIn ? '' : config.links.dp_sales.replace('${locale}', current_lang) }, 
        { title: <FormattedMessage id="footer.column-one-link-one"/>,  url: '/contact'}, 
        { title: <FormattedMessage id="footer.column-one-link-two"/> , url: '/faq' },
        { title: <FormattedMessage id="link.terms-and-conditions-text"/>,   extUrl: market_config?.terms_of_use },
        { title: <FormattedMessage id="link.privacy-text"/>,   extUrl: market_config?.privacy_notice },
    ];
    const aboutLinks = [
        { title: <FormattedMessage id="footer.dp-marketing-text"/>,   extUrl: config?.links?.dp_marketing?.replace('${locale}', current_lang) },
        { title: <FormattedMessage id="footer.about-philips-text"/>,  extUrl: config?.links?.about?.replace('${locale}', current_lang) }
    ]
    const extraLinks = market_config?.name === "DE" ? [
        { title: "Investor Relations",  extUrl: 'https://www.philips.com/a-w/about/investor-relations.html'},
        { title: "Karriere",  extUrl: 'https://www.careers.philips.com/de/de'},
        { title: "Kontakt zu Philips",  extUrl: 'https://www.philips.de/a-w/about.html'},
    ] : [];

    //TODO: if more markets wanna add extra links we should consider putting these in the admin for now the links below are only used for DE (Germany)
    const generalLinks = market_config?.name === "DE" ? [
        { title: "Öffentliches Verfahrensverzeichnis",  extUrl: 'https://www.philips.de/a-w/oeffentliches-verfahrensverzeichnis.html'},
        { title: "Impressum",  extUrl: 'https://www.philips.de/a-w/herausgeber.html'},
        { title: "Cookie-Richtlinie",  extUrl: 'https://www.philips.de/a-w/datenschutzbestimmungen.html'},
        { title: "Datenschutzbestimmungen",  extUrl: 'https://www.philips.de/a-w/datenschutzbestimmungen.html'},
        { title: "Nutzungsbedingungen",  extUrl: 'https://www.philips.de/a-w/nutzungsbedingungen.html'},
    ] : [];


    //  if(config?.links?.terms_and_conditions){
    //         supportLinks.push({ 
    //             title: <FormattedMessage id="footer.column-one-link-tc"/>, 
    //             extUrl: config.links.terms_and_conditions.replace('${locale}', current_lang)
    //         })
    //     };
    //  }

    // if(config?.links?.terms_of_use){
    //     supportLinks.push({ 
    //         title: <FormattedMessage id="footer.column-one-link-tu"/>, 
    //         extUrl: config.links.terms_of_use.replace('${locale}', current_lang)
    //     })
    // };
 
    // calc number of link cols
    
    const ncols = extraLinks.length > 0 || locales_admin?.length > 1 ? 4 : 3;
    const cwith = Math.floor( 12/ncols ) 

    return (
        <Box sx={{backgroundColor: theme.palette.primary.main, width: '100%', paddingTop: '93px', paddingBottom: '93px', overflow: 'hidden' }}>
            <Grid container direction={{ xs: 'column', sm:'row' }} sx={{ maxWidth: contentWidth, marginRight: 'auto', marginLeft: 'auto' }} spacing={2}>
                <Grid item xs={cwith}>
                    <img src={logo} height="76" alt="Philips Logo white" />
                </Grid>
                
                <Grid item xs={cwith}>
                    <Typography variant="bold" color="primary.light">
                        <FormattedMessage id="footer.column-one-header"/>
                    </Typography>
                    <Box mt={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                        { supportLinks.map( (link, i) => <>
                            {link.url ? <NavLink           key={`${link?.title}` + i} style={{color: theme.palette.primary.light}} to={link.url}>{ link.title }</NavLink>
                                      : <a target="_blank" key={`${link?.title}` + i} style={{color: theme.palette.primary.light}} href={link.extUrl} rel="noreferrer">{ link.title }</a> }
                        </>)}
                    </Box>
                </Grid>
                
                <Grid item xs={cwith}>
                    <Typography variant="bold" color="primary.light">
                        <FormattedMessage id="footer.column-two-header"/>
                    </Typography>
                    <Box mt={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                        { aboutLinks.map( (link, i) => <>
                            {link.url ? <NavLink           key={`${link?.title}` + i} style={{color: theme.palette.primary.light}} to={link.url}>{ link.title }</NavLink>
                                      : <a target="_blank" key={`${link?.title}` + i} style={{color: theme.palette.primary.light}} href={link.extUrl} rel="noreferrer">{ link.title }</a> }
                        </>)}
                    </Box>
                    {/* <span style={{ color: 'rgb(0, 43, 92)'}}>v new api</span> */}
                </Grid>
                
                {ncols === 4 &&             
                    <Grid item xs={cwith}>
                        <Typography variant="bold" color="primary.light">
                            <FormattedMessage id="footer.about-philips-text"/>
                        </Typography>
                        <Box mt={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                            { extraLinks.map( (link, i) => <>
                                {link.url ? <NavLink         key={`${link?.title}` + i} style={{color: theme.palette.primary.light}} to={link.url}>{ link.title }</NavLink>
                                        : <a target="_blank" key={`${link?.title}` + i} style={{color: theme.palette.primary.light}} href={link.extUrl} rel="noreferrer">{ link.title }</a> }
                            </>)}
                        </Box>
                        {locales_admin?.length > 1 && <>
                            <Typography variant="bold" color="primary.light">
                                <FormattedMessage id="footer.column-three-header"/>
                            </Typography>
                            <Box mt={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                                <LocalizationSection nav={false} />
                            </Box>
                        </>}    
                        {/* <span style={{ color: 'rgb(0, 43, 92)'}}>v new api</span> */}
                    </Grid>
                }
            </Grid>


            <Grid container direction={{ xs: 'column', sm:'row' }} sx={{ maxWidth: contentWidth, marginTop: '100px', marginRight: 'auto', marginLeft: 'auto' }} spacing={2}>
                <Grid item xs={8}>
                {generalLinks.length >= 1 &&
                    // <Box sx={{paddingX: '16px', maxWidth: contentWidth, marginTop: {xs: '25px', sm:'100px'}, marginRight: 'auto', marginLeft: 'auto'}}>
                        <Box mt={2} sx={{display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, _gap: '0.2rem', flexWrap: 'wrap', justifyContent: { xs: 'flex-start', sm: 'flex-start' }, alignItems: { xs: 'flex-start', sm: 'center' }}}>
                            {generalLinks.map((link, i) => {
                                const isLast = i === generalLinks.length - 1;
                                const linkElement = link.url ? (
                                    <NavLink key={i} style={{color: theme.palette.primary.light, display: 'inline-flex', marginRight: '1rem'}} to={link.url}>{link.title}</NavLink>
                                ) : (
                                    <a key={i} target="_blank" style={{color: theme.palette.primary.light, display: 'inline-flex', marginRight: '1rem'}} href={link.extUrl} rel="noreferrer">{link.title}</a>
                                );
                                // Only add a pipe after the link if it's NOT the last one
                                return (
                                    <Typography variant="small" color="primary.light">
                                        {linkElement}
                                        {/* {!isLast && (
                                            <Box component="span" sx={{ padding: '0 8px 10px', color: theme.palette.primary.light, display: { xs: 'none', sm: 'inline' }}}>|</Box>
                                        )} */}
                                    </Typography>
                                );
                            })}
                        </Box>
                    // </Box>
                }
                </Grid>
                <Grid item xs={4}>
                    <Box mt={2} sx={{display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, _gap: '0.2rem', flexWrap: 'wrap', justifyContent: { xs: 'flex-start', sm: 'flex-start' }, alignItems: { xs: 'flex-start', sm: 'center' }}}>
                    <Typography variant="extraSmall" color="primary.light">
                        © Koninklijke Philips N.V. 2004 - {new Date().getFullYear()}. <FormattedMessage id="footer.bottom-right-copyright"/>
                    </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};


export default Footer;
